/**
 * External dependencies
 */
export default class Uninstall {
    constructor(cscom) {
        if (!(this instanceof Uninstall)) {
            return new Uninstall(cscom);
        }
        this.cscom = cscom;
    }

    getUninstallResponse() {
        return this.cscom.req.get('/sgc/app/get-uninstall');
    }

    verifyUninstall(hmac, host, session, shop, timestamp) {
        if (session) {
            return this.cscom.req.get('/sgc/app/uninstall', { hmac, host, session, shop, timestamp });
        } else {
            return this.cscom.req.get('/sgc/app/uninstall', { hmac, host, shop, timestamp });
        }
    }
}
